import script from "./ConfiguratorPriceBrackets.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfiguratorPriceBrackets.vue?vue&type=script&setup=true&lang=ts"

import "./ConfiguratorPriceBrackets.vue?vue&type=style&index=0&id=3650fb48&lang=css"

const __exports__ = script;

export default __exports__